<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="icon-pencil"></i> Mobile punch settings
					</template>
					<b-card-body>
						<b-form>
							<b-form-group
								label="Office"
								label-for="Office"
								:label-cols="3"
								:horizontal="true">
								<multiselect @input="getOfficeMobilePunchSettings()" v-model="selectedOffice"
														 :options="officeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</b-form-group>
							<b-form-group
								v-if="selectedOffice !== null"
								label="Selfies Verification Required"
								label-for="selfieVerificationRequired"
								:label-cols="3"
								:horizontal="true">
								<b-form-select
									v-model="mobilePunchEnabled"
									:options="mobilePunchStatusOptions"
									class="mb-3"
									value-field="value"
									text-field="name"
								></b-form-select>
							</b-form-group>
							<b-form-group
								v-if="availableGeneralSettings.length > 0"
								v-for="settings in availableGeneralSettings" :key="settings.id"
								:label="settings.generalSettingsKey.keyName"
								:label-cols="3"
								:horizontal="true">
								<b-form-select
									v-if="settings.generalSettingsKey.possibleValues !== null"
									v-model="settings.generalSettingsKey.setValue"
									:options="settings.generalSettingsKey.possibleValues.values"
									class="mb-3"
									value-field="value"
									text-field="name"
									disabled-field="notEnabled"
								></b-form-select>
								<b-form-input
									v-model="settings.generalSettingsKey.setValue"
									v-if="settings.generalSettingsKey.possibleValues == null"
									placeholder="Enter Value">
								</b-form-input>
							</b-form-group>
							<div class="form-actions">
								<b-button v-if="$store.getters.canWrite" type="button" variant="success" @click="updateGeneralSettingsOfOffice()">Save</b-button>
							</div>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import toastService from "@/services/toastService";
	import officeService from "../../services/officeService";
	import Multiselect from 'vue-multiselect'
	import generalSettingsService from "@/services/generalSettingsService";
	import generalSettingsGroupIds from '@/services/generalSettingsGroupIds';
	const MOBILE_PUNCH_GENERAL_SETTINGS_GROUP_ID = 1;
	export default {
		name: "MobilePunchGeneralSettings",
		components : {
			Multiselect
		},
		data : function ()  {
			return {
				officeList: [],
				selectedOffice: null,
				mobilePunchSettingsData :[],
				availableGeneralSettings:[],
				mobilePunchEnabled: false,
				selfieVerificationSetting: null,
				mobilePunchStatusOptions: [
					{ value: true, name: 'Enabled' },
					{ value: false, name: 'Disabled' }
				]
			}
		},
		methods : {
			getOfficeMobilePunchSettings(){
				this.availableGeneralSettings = [];
				this.mobilePunchEnabled = false;
				this.selfieVerificationSetting = null;
				if(this.selectedOffice != null){
					generalSettingsService.getGeneralSettings(
						{officeId : this.selectedOffice.id, groupId: generalSettingsGroupIds.MOBILE_PUNCH_SETTINGS_ID}
						, (data) => {
							data.forEach(d=>{
								d.generalSettingsKey.possibleValues = JSON.parse(d.generalSettingsKey.possibleValues);
								const setValue = d.generalSettingsKey.setValue;
								if(setValue === null || setValue === undefined || setValue === ''){
									if(d.generalSettingsKey.keyName === 'Minimum time interval between punches on same location'){
										d.generalSettingsKey.setValue = 0;
									} else if(d.generalSettingsKey.keyName === 'Maximum distance from workplace in metres'){
										d.generalSettingsKey.setValue = 50;
									}
								}
							});
							const selfieIndex = data.findIndex(d => d.generalSettingsKey.keyCode === 'SELFIE_VERIFICATION_REQUIRED');
							if(selfieIndex !== -1){
								this.selfieVerificationSetting = data[selfieIndex];
								const sv = this.selfieVerificationSetting.generalSettingsKey.setValue;
								this.mobilePunchEnabled = sv === 'true';
								data.splice(selfieIndex, 1);
							}
							this.availableGeneralSettings = data;
						});
				}
			},
			updateGeneralSettingsOfOffice(){
				let data = {};
				data.settings = this.availableGeneralSettings.map( g => {
					return{
						groupId: g.groupId,
						keyId : g.generalSettingsKey.id,
            keyCode: g.generalSettingsKey.keyCode,
						setValue: g.generalSettingsKey.setValue,
						officeGroupKeyId : g.generalSettingsKey.officeGroupKeyId,
					}
				});
				if(this.selfieVerificationSetting !== null){
					data.settings.push({
						groupId: MOBILE_PUNCH_GENERAL_SETTINGS_GROUP_ID,
						keyId: this.selfieVerificationSetting.generalSettingsKey.id,
						keyCode: 'SELFIE_VERIFICATION_REQUIRED',
						setValue: this.mobilePunchEnabled,
						officeGroupKeyId: this.selfieVerificationSetting.generalSettingsKey.officeGroupKeyId,
					});
				}
				data.officeId = this.selectedOffice.id;
				data.groupId = MOBILE_PUNCH_GENERAL_SETTINGS_GROUP_ID;
				generalSettingsService.updateGeneralSettingsOfAnOffice(data, ()=> toastService.showSuccessToast("Updated Successfully"),
					()=> toastService.showErrorToast("Update failed"));
			}
		},
		mounted() {
			officeService.getOfficeList( r => {
				this.officeList = r;
			});
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
